export const HELP_CENTER_CONTENT = {
    /** TOPICS */
    '/dashboard': {
        WEB_URL: 'topic/getting-started-with-kidsday-an-overview',
        CATEGORY_ID: null,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/parents': {
        WEB_URL: 'topic/how-to-add-a-parent-in-kidsday',
        CATEGORY_ID: 1,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/staff': {
        WEB_URL: 'topic/how-to-add-staff-in-kidsday',
        CATEGORY_ID: 1,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/development-reports': {
        WEB_URL: 'topic/how-to-create-development-form',
        CATEGORY_ID: 7,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/settings': {
        WEB_URL: 'topic/how-to-update-daycare-center-settings',
        CATEGORY_ID: 1,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/planners/activity': {
        WEB_URL: 'topic/how-to-plan-activities-on-kidsday',
        CATEGORY_ID: 2,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/planners/event': {
        WEB_URL: 'topic/how-to-notify-parents-about-events-and-announcements',
        CATEGORY_ID: 2,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/planners/appointment': {
        WEB_URL: 'topic/how-to-organize-meetings-with-parents-in-the-kidsday',
        CATEGORY_ID: 2,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/space/forms': {
        WEB_URL: 'topic/how-to-manage-registration-forms-in-kidsday',
        CATEGORY_ID: 4,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/space/contracts': {
        WEB_URL: 'topic/how-to-manage-contracts-and-automate-invoices-in-kidsday',
        CATEGORY_ID: 4,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/space/billing': {
        WEB_URL: 'topic/how-to-access-the-billing-overview-in-kidsday',
        CATEGORY_ID: 5,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/space/billing/payments': {
        WEB_URL: 'topic/how-to-register-a-payment-in-kidsday',
        CATEGORY_ID: 5,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/reporting/attendances': {
        WEB_URL: 'topic/how-to-generate-a-monthly-attendance-report-for-children-in-kidsday',
        CATEGORY_ID: 6,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/reporting/staff-attendance': {
        WEB_URL: 'topic/how-to-register-staff-attendance-in-kidsday',
        CATEGORY_ID: 6,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/profile': {
        WEB_URL: 'topic/how-to-update-the-profile-in-kidsday',
        CATEGORY_ID: 7,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/space/billing/invoices': {
        WEB_URL: 'topic/how-to-manage-invoices-in-kidsday-billing-section',
        CATEGORY_ID: 5,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/settings/meals': {
        WEB_URL: 'topic/how-to-update-meal-configurations-in-kidsday',
        CATEGORY_ID: 2,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/space/billing/configurations': {
        WEB_URL: 'topic/how-to-update-billing-configurations',
        CATEGORY_ID: 5,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/space/products': {
        WEB_URL: 'topic/how-to-register-prices-for-payment-invoices-in-kidsday',
        CATEGORY_ID: 5,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },


    /** LINKS */
    '/classes/view': {
        WEB_URL: 'link/1',
        CATEGORY_ID: 1,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/children': {
        WEB_URL: 'link/2',
        CATEGORY_ID: 1,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/planners': {
        WEB_URL: 'link/3',
        CATEGORY_ID: 2,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
    '/messages': {
        WEB_URL: 'link/4',
        CATEGORY_ID: 3,
        LANGUAGES: ['en-us', 'sq-al', 'mk-mk'],
    },
}
